import { Component } from '@angular/core';
import { SERVICE_SETTINGS_CONTACTS_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';

@Component({
    selector: 'app-service-settings-contacts',
    templateUrl: './service-settings-contacts.component.html',
    styleUrl: './service-settings-contacts.component.scss',
    imports: [
        ServiceSettingsCommonComponent,
    ],
})
export class ServiceSettingsContactsComponent {
    protected readonly SERVICE_SETTINGS_CONTACTS_TYPE_KEY = SERVICE_SETTINGS_CONTACTS_TYPE_KEY;
}
